export default __webpack_public_path__ + "static/media/HDFC-Ergo-logo.7716d4e5.svg";